import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'ShowResult',
    component: () => import('../views/ShowResult.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
